import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Pane, Select, Dialog } from "evergreen-ui";
import gql from "graphql-tag";

const GET_USERS = gql`
  query Users {
    users {
      _id
      email
      role
      name
    }
  }
`;

const CHANGE_USER = gql`
  mutation ChangeUser($id: String!, $role: String!) {
    changeUser(_id: $id, role: $role)
  }
`;

const DELETE_USER = gql`
  mutation DeleteUser($id: String!) {
    deleteUser(_id: $id)
  }
`;

const MODIFY_USER = gql`
  mutation ModifyUser($id: String!, $email: String!, $name: String!) {
    changeUser(_id: $id, email: $email, name: $name)
  }
`;

const REGISTER_USER = gql`
  mutation RegisterUser($name: String!, $email: String!, $role: String!) {
    registerUser(name: $name, email: $email, role: $role)
  }
`;

export default () => {
  const { data, error, loading } = useQuery(GET_USERS);
  const [changeUser] = useMutation(CHANGE_USER);
  const [modifyUser] = useMutation(MODIFY_USER);
  const [registerUser] = useMutation(REGISTER_USER);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [changingName, setChangingName] = useState("");
  const [changingEmail, setChangingEmail] = useState("");

  const [dialogShown, setDialogShown] = useState(false);
  const [editedId, setEditedId] = useState(0);

  if (error) return <Pane>Error</Pane>;
  if (loading) return <Pane>Ładowanie...</Pane>;
  return (
    <Pane>
      <Dialog
        isShown={dialogShown}
        title="Edycja usera"
        onCloseComplete={() => {
          setDialogShown(false);
        }}
        confirmLabel="Zmień usera"
        cancelLabel="Anuluj"
        onConfirm={() => {
          modifyUser({
            variables: {
              name: changingName,
              email: changingEmail,
              id: editedId
            },
            refetchQueries: ["Users"]
          });
          setChangingName("");
          setChangingEmail("");
          setDialogShown(false);
        }}
      >
        <input
          placeholder="NAZWA USERA"
          value={changingName}
          onChange={e => setChangingName(e.target.value)}
        />
        <input
          placeholder="EMAIL USERA"
          value={changingEmail}
          onChange={e => setChangingEmail(e.target.value)}
        />
      </Dialog>
      {data.users.map(user => (
        <Pane>
          {user.name} - {user.email}{" "}
          <span
            onClick={() => {
              setEditedId(user._id);
              setChangingEmail(user.email);
              setChangingName(user.name);
              setDialogShown(true);
            }}
          >
            Edit
          </span>
          <br />
          <Select
            value={user.role}
            onChange={e => {
              changeUser({
                variables: { id: user._id, role: e.target.value },
                refetchQueries: ["Users"]
              });
            }}
          >
            <option value="user">user</option>
            <option value="admin">admin</option>
            <option value="deactivated">nieaktywny</option>
          </Select>
        </Pane>
      ))}
      <input
        placeholder="NAZWA USERA"
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <input
        placeholder="EMAIL USERA"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <button
        onClick={() => {
          registerUser({
            variables: { name: name, email: email, role: "user" },
            refetchQueries: ["Users"]
          });
          setName("");
          setEmail("");
        }}
      >
        register
      </button>
    </Pane>
  );
};
